import { ListItem, Stack, Typography, ListItemAvatar, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { shouldForwardPropHelper } from '@engyalo/design-system';

interface IItem {
  isSelected: boolean;
  isCurrentChat: boolean;
}

export const Item = styled(ListItem, {
  shouldForwardProp: shouldForwardPropHelper,
})<IItem>`
  background-color: ${({ isSelected, isCurrentChat, ...props }) =>
    isSelected || isCurrentChat ? props.theme.palette.neutral.var20 : props.theme.palette.common.white};
  padding: 8px 8px 8px 8px;
  cursor: pointer;
  user-select: none;
  &:hover {
    background: ${({ isSelected, isCurrentChat, ...props }) =>
      isSelected || isCurrentChat ? props.theme.palette.neutral.var20 : props.theme.palette.neutral.var10};
  }
`;

export const TitleContainer = styled(Stack)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
`;

export const ItemTitleAllChatsContainer = styled(Stack)`
  display: flex;
  flex-direction: row;
`;

export const TitleSeparator = styled('p')`
  color: ${(props) => props.theme.palette.neutral.var30};
  margin-inline: 6px;
  font-weight: inherit;
`;

export const ItemTime = styled(Typography)`
  white-space: nowrap;
  margin-left: 2px;
`;

export const ChevronIcon = styled('i')`
  margin-left: 4px;
  color: ${(props) => props.theme.palette.neutral.var50};
`;

export const ItemBody = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
`;

export const OptionsContainerChat = styled('span')`
  display: flex;
  align-items: start;
  gap: 0.2rem;
  margin-left: 0.4rem;
`;

export const UnreadBadge = styled('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  height: 1.6rem;
  max-width: 3.2rem;
  background: ${(props) => props.theme.palette.primary.dark};
  border-radius: 1rem;
  align-items: center;
  text-align: center;
  color: ${(props) => props.theme.palette.common.white};
  font-size: 1rem;
  font-weight: 400;
`;

export const UnreadIndicator = styled('span')`
  border-width: 2px;
  border-style: solid;
  border-color: ${(props) => props.theme.palette.primary.dark};
  margin: auto 6px auto 0;
  border-radius: 2px;
`;

export const Options = styled('span')`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  color: ${(props) => props.theme.palette.neutral.var90};
  visibility: visible;

  ${({ theme }) => theme.breakpoints.down('md')} {
    visibility: hidden;
  }

  #itemChat:hover & {
    visibility: visible;
    width: 1.6rem;
  }
`;

interface IClientNameEllipsis {
  isOnlyClientName: boolean;
  isAgentOrDepartmentName: boolean;
}

export const ClientNameEllipsis = styled(Typography, {
  shouldForwardProp: shouldForwardPropHelper,
})<IClientNameEllipsis>`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: inherit;
  max-width: ${({ isOnlyClientName, isAgentOrDepartmentName }) =>
    isOnlyClientName ? '165px' : isAgentOrDepartmentName ? '45%' : '86px'};
`;

export const LastMessage = styled(Typography)(
  () => `
  > i {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-right: 0.4rem; 
  }
`
);

export const ItemContent = styled(Stack)`
  display: flex;
  flex-direction: column;
`;

interface IAvatarContainer {
  hasUnreadmessages: boolean;
}

export const AvatarContainer = styled(ListItemAvatar, {
  shouldForwardProp: shouldForwardPropHelper,
})<IAvatarContainer>`
  margin-top: auto;
  margin-right: 8px;
  margin-bottom: auto;
  margin-left: ${({ hasUnreadmessages }) => (hasUnreadmessages ? '0' : '10px')};
  min-width: unset;
`;

export const ChatDetails = styled(ListItemText)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
